import { device, IconSvg } from 'monica-alexandria';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const SidebarOptions = styled.div`
  padding-bottom: 2rem;

  h6:not(:first-child) {
    margin-top: 2rem;
  }
`;

const SidebarOptionsBox = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem;
  padding-left: 4rem;
  cursor: pointer;
  background: ${(p) => (p.active ? p.theme.low : 'transparent')};

  svg {
    width: 3rem;
    fill: ${(p) => (p.active ? 'var(--main)' : p.theme.color)};
  }

  h5 {
    color: ${(p) => (p.active ? 'var(--main)' : p.theme.color)};
  }

  &:hover {
    background: ${(p) => p.theme.mid};
  }

  @media ${device.sm} {
    padding-left: 2rem;

    h5 {
      display: ${(p) => (p.sidebar ? 'block' : 'none')};
    }

    svg {
      width: 3.5rem;
    }
  }
`;

export const Sidebar_Options = (props) => {
  const { t } = useTranslation();

  const statsOptions = [
    {
      key: 'goals',
      icon: 'Analytics',
      text: t('Goals'),
      active: props.activeOption === 'goals',
      onClick: props.onGoalsClick
    }
  ].filter((option) => option.onClick);

  const boardOptions = [
    {
      key: 'agency',
      icon: 'Analytics',
      text: t('Agency'),
      active: props.activeOption === 'agency',
      onClick: props.onAgencyClick
    },
    {
      key: 'sass',
      icon: 'File',
      text: t('Sass'),
      active: props.activeOption === 'sass',
      onClick: props.onSassClick
    }
  ].filter((option) => option.onClick);

  return (
    <SidebarOptions>
      {boardOptions.length ? <h6>{t('BOARDS')}</h6> : null}
      {boardOptions.map((option) => (
        <SidebarOptionsBox key={option.key} sidebar={props.sidebar} active={option.active} onClick={option.onClick}>
          <IconSvg Icon={option.icon} />
          <h5>{option.text}</h5>
        </SidebarOptionsBox>
      ))}
      {statsOptions.length ? <h6>{t('STATS')}</h6> : null}
      {statsOptions.map((option) => (
        <SidebarOptionsBox key={option.key} sidebar={props.sidebar} active={option.active} onClick={option.onClick}>
          <IconSvg Icon={option.icon} />
          <h5>{option.text}</h5>
        </SidebarOptionsBox>
      ))}
    </SidebarOptions>
  );
};
